import React, { useState, useEffect } from 'react';
import { Form, Input, Row, Col, Button, Space, Modal } from 'antd';
import { apiRequest } from '../../../../../service/apiRequest';
import { showSuccess, showError } from '../../../../../components/errorHandler';

interface StateModalProps {
  visible: boolean;
  onCancel: () => void;
  onCreate: (data: any) => void;
  initialValues?: {
    state_id?: number;
    state_name?: string;
  } | null;
  isEditMode?: boolean;
}

const StateModal: React.FC<StateModalProps> = ({
  visible,
  onCancel,
  onCreate,
  initialValues = null,
  isEditMode = false,
}) => {
  const [form] = Form.useForm();
  const [isModalClose, setIsModalClose] = useState(true);

  const isSubmitDisabled = () => {
    const errors = form.getFieldsError();
    return errors.some(({ errors }) => errors.length > 0);
  };

  const handleAddState = async (values: any) => {
    try {
      const dataVal = {
        state_name: values.state_name,
        ...(initialValues?.state_id && { state_id: initialValues.state_id }),
      };

      const url = isEditMode ? 'edit-state' : 'add-state';
      const method = isEditMode ? 'put' : 'post';

      const data = await apiRequest({
        method,
        url,
        data: dataVal,
      });

      onCreate(data);
      showSuccess(
        isEditMode ? 'State updated successfully!' : 'State created successfully!'
      );

      form.resetFields();

      if (isModalClose) onCancel();
    } catch (error) {
      showError(`Failed to ${isEditMode ? 'update' : 'create'} state`);
    }
  };

  useEffect(() => {
    if (visible && isEditMode && initialValues) {
      form.setFieldsValue({ state_name: initialValues.state_name });
    } else if (visible) {
      form.resetFields();
    }
  }, [visible, isEditMode, initialValues, form]);

  return (
    <Modal
      title={isEditMode ? 'Edit State' : 'Add New State'}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width="50%"
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleAddState} autoComplete="off">
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="state_name"
              label={
                <span>
                  State&nbsp;
                  <span style={{ fontSize: '12px', color: '#888' }}>
                    (Max 255 characters)
                  </span>
                </span>
              }
              rules={[
                { required: true, message: 'Please enter the State' },
                { max: 255, message: 'Maximum 255 characters allowed' },
              ]}
            >
              <Input showCount maxLength={255} placeholder="e.g., California" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Space>
            <Button onClick={onCancel}>Cancel</Button>
            {!isEditMode && (
              <Button
                type="primary"
                htmlType="submit"
                onClick={() => setIsModalClose(false)}
                disabled={isSubmitDisabled()}
              >
                Submit & Create New State
              </Button>
            )}
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => setIsModalClose(true)}
              disabled={isSubmitDisabled()}
            >
              Submit
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default StateModal;
